import banner from "../assets/img/banner-1.jpg";
const Home = () => {
  return (
    <div style={{ paddingBottom: "20px", paddingTop: "22px" }}>
      <img src={banner} className="banner" alt="banner"></img>
    </div>
  );
};
export default Home;
